module.exports = __webpack_public_path__ + "img/logo_aluk.30762d13.png";